import $ from 'jquery'

export default function csrf() {
  var csrf = $('input.csrf')
  var obj = {}
  obj[csrf.data('header-name')] = csrf.val()
  return obj
}
